import {SET_GAINSIGHT_LOADED} from "./actions";

export const INITIAL_STATE = {
  gainsightLoaded: false
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_GAINSIGHT_LOADED:
      return {
        ...state,
        ...action.payload
      };
    default:
      return state;
  }
};
